import { HttpContextToken } from '@angular/common/http';

export const ADD_BEIHILFE_LEGACY_HEADER_TOKEN = new HttpContextToken<boolean>(() => false);
